import { render, staticRenderFns } from "./ServiceModal.vue?vue&type=template&id=105a5332&scoped=true"
import script from "./ServiceModal.vue?vue&type=script&lang=js"
export * from "./ServiceModal.vue?vue&type=script&lang=js"
import style0 from "./ServiceModal.vue?vue&type=style&index=0&id=105a5332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105a5332",
  null
  
)

export default component.exports